import logoUrl from '@/shared/assets/logo.svg'
import { Mail, MessageCircle, Phone } from 'lucide-react'
import { t } from '@/shared/lib/i18n'
import { Card, CardContent } from '@/shared/ui/card'

interface ContactCardProps {
  icon: React.ReactNode
  heading: string
  children: React.ReactNode
}

const ContactCard = ({ icon, heading, children }: ContactCardProps) => (
  <Card className="flex flex-1 flex-col items-center px-6 py-8 text-center">
    <CardContent className="flex flex-col items-center gap-4 p-0">
      <div className="flex size-14 items-center justify-center rounded-full border-2 border-primary/30 text-primary">
        {icon}
      </div>
      <h2 className="text-lg font-semibold">{heading}</h2>
      {children}
    </CardContent>
  </Card>
)

const ContactUsShow = () => {
  return (
    <div className="w-full px-4 py-10">
      <div className="mb-10 flex justify-center">
        <img src={logoUrl} alt={t('nav.appName')} className="h-16 w-auto" />
      </div>

      <h1 className="mb-8 text-center text-2xl font-semibold tracking-tight">
        {t('contactUs.pageTitle')}
      </h1>

      <div className="flex flex-col gap-4 sm:flex-row sm:gap-6 lg:gap-8">
        <ContactCard
          icon={<Phone className="size-6" strokeWidth={1.75} />}
          heading={t('contactUs.callUs.heading')}
        >
          <div className="space-y-1 text-sm">
            <p>
              <a href="tel:1-844-522-5647" className="font-semibold text-primary hover:underline">
                {t('contactUs.callUs.phone')}
              </a>
            </p>
            <p>
              <a href="tel:1-844-522-5647" className="font-semibold text-primary hover:underline">
                {t('contactUs.callUs.phoneAlt')}
              </a>
            </p>
            <p className="mt-2 text-blue-500">{t('contactUs.callUs.hours')}</p>
          </div>
        </ContactCard>

        <ContactCard
          icon={<Mail className="size-6" strokeWidth={1.75} />}
          heading={t('contactUs.writeUs.heading')}
        >
          <p className="text-sm">
            <a
              href={`mailto:${t('contactUs.writeUs.email')}`}
              className="font-semibold text-primary hover:underline"
            >
              {t('contactUs.writeUs.email')}
            </a>
          </p>
        </ContactCard>

        <ContactCard
          icon={<MessageCircle className="size-6" strokeWidth={1.75} />}
          heading={t('contactUs.needHelp.heading')}
        >
          <p className="text-sm font-semibold text-blue-500">
            {t('contactUs.needHelp.instruction')}
          </p>
        </ContactCard>
      </div>
    </div>
  )
}

export default ContactUsShow
